<template>
  <Card :title="title" data-testid="team_card">
    <template slot="content">
      <div class="d-flex">
        <div class="team__leader">
          <p data-testid="owner-role" class="team-member__role">
            {{ ownerText }}
          </p>
          <TeamMember
            data-testid="owner"
            :avatarMediaObject="owner.avatarMediaObject"
            :name="owner.name"
            :lastName="owner.lastName"
            :email="owner.email"
          />
        </div>
        <div class="team__leader" v-if="coach.name">
          <p data-testid="coach-role" class="team-member__role">
            {{ coachText }}
          </p>
          <TeamMember
            data-testid="coach"
            :avatarMediaObject="coach.avatarMediaObject"
            :name="coach.name"
            :lastName="coach.lastName"
            :email="coach.email"
          />
        </div>
      </div>
      <p
        data-testid="member-role"
        class="team-member__role my-2"
        v-if="members.length"
      >
        {{ membersText }}
      </p>

      <div
        class="team__collaborator mb-2"
        v-for="(member, index) in members"
        :key="index"
      >
        <TeamMember
          :data-testid="`team-member-${index}`"
          :avatarMediaObject="member.avatarMediaObject"
          :name="member.name"
          :lastName="member.lastName"
          :email="member.email"
        />
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/RevPrint/Card'
import TeamMember from '@/components/RevPrint/TeamMember.vue'

export default {
  name: 'PrintTeam',

  components: {
    Card,
    TeamMember,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    ownerText: {
      type: String,
      required: true,
    },
    coachText: {
      type: String,
      required: true,
    },
    membersText: {
      type: String,
      required: true,
    },
    owner: {
      type: Object,
      required: true,
    },
    coach: {
      type: Object,
      required: true,
    },
    members: {
      type: Array,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen, print {
  .team-member__role {
    font-size: 10px;
    font-weight: bold;
    color: $color-blue-darken2;
  }
  .team__collaborator {
    width: 30% !important;
    flex: 1;
    display: inline-block !important;
  }
  .team__leader {
    width: 30% !important;
  }
}
</style>
